import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "news-card__image-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "news-card__gradient" }, null, -1)
const _hoisted_3 = {
  key: 2,
  class: "news-card__gallery-badge"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Galéria ")
const _hoisted_5 = {
  key: 3,
  class: "timer news-card__timer"
}
const _hoisted_6 = { class: "timer__text" }
const _hoisted_7 = {
  key: 0,
  class: "news-card__image-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentImage = _resolveComponent("ContentImage")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_GalleryFull = _resolveComponent("GalleryFull")!
  const _component_Play = _resolveComponent("Play")!

  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(["news-card news-card--8-4", {
      'news-card--large': _ctx.size === 'large',
      'news-card--bordered': _ctx.showBorder
    }])
  }, [
    (_ctx.size === 'large')
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.navigation ? 'nav-link' : 'div'), _normalizeProps(_mergeProps({ key: 0 }, _ctx.navigation ? { to: _ctx._url, target: _ctx.target } : {})), {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode(_component_ContentImage, {
                class: "news-card__image",
                "image-url": _ctx.imageUrl,
                "preview-url": _ctx.previewUrl,
                loading: "lazy"
              }, null, 8, ["image-url", "preview-url"]),
              (_ctx.title)
                ? (_openBlock(), _createElementBlock("h3", {
                    key: 0,
                    class: _normalizeClass(["news-card__title", { 'news-card__title--highlighted': _ctx.titleHighlighted }])
                  }, _toDisplayString(_ctx.title), 3))
                : _createCommentVNode("", true),
              (_ctx.tag && _ctx.showTag)
                ? (_openBlock(), _createBlock(_component_Tag, {
                    key: 1,
                    class: "news-card__tag",
                    tag: _ctx.tag,
                    "is-live": _ctx.isLive
                  }, null, 8, ["tag", "is-live"]))
                : _createCommentVNode("", true),
              (_ctx.showGalleryBadge && _ctx.isGallery)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_GalleryFull),
                    _hoisted_4
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showDuration && _ctx.isVideo && _ctx.videoDuration)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_Play, { class: "timer__play" }),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.videoDuration), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 16))
      : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.navigation ? 'nav-link' : 'div'), _normalizeProps(_mergeProps({ key: 1 }, _ctx.navigation ? { to: _ctx._url, target: _ctx.target } : {})), {
          default: _withCtx(() => [
            (_ctx.showImage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_ContentImage, {
                    class: "news-card__image",
                    "image-url": _ctx.imageUrl,
                    "preview-url": _ctx.previewUrl,
                    alt: _ctx.title,
                    "is-lcp": _ctx.isLcp
                  }, null, 8, ["image-url", "preview-url", "alt", "is-lcp"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.title)
              ? (_openBlock(), _createElementBlock("h3", {
                  key: 1,
                  class: _normalizeClass(["news-card__title news-card__title--cropped", { 'news-card__title--highlighted': _ctx.titleHighlighted,  'news-card__title--no-image': !_ctx.showImage }])
                }, _toDisplayString(_ctx.title), 3))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 16))
  ], 2))
}